<template>
	<div
		class="job-hierarchy-box tw-flex tw-flex-col tw-items-center tw-justify-center"
		:class="{
		'has-error': assignationHasError,
		'selected': selected,
		'clickable': clickable,
	}"
		@click="onSelectedClick"
	>
		<template v-if="!(jobPosition.fatherId && jobPosition.fatherId !== selectedJobPosition.id)">
			<check-icon-toggle
				class="check-assignation"
				v-if="selectedJobPosition.id && selectable"
				@click="onAssignClicked"
				:checked="jobPosition.fatherId"
			/>
		</template>
		<p class="tw-m-0 tw-text-center">{{ jobPosition.name }}</p>
		<p class="tw-m-0 tw-text-center job-father" v-if="jobPosition.fatherName">({{ jobPosition.fatherName }})</p>
		<div v-if="assignationHasError" class="tw-mt-2">
			<edit-icon color="error" @click="onEditClick" class="edit-button" />
		</div>
		<job-selector-edition-dialog ref="jobSelectorEditionDialog" />
	</div>
</template>

<script>
import EditIcon from '@/modules/shared/components/icons/edit-icon';
import JobSelectorEditionDialog
	from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-selector-edition-dialog';
import CheckIcon from '@/modules/shared/components/icons/check-icon';

import { assoc, pipe } from 'ramda';
import CheckIconToggle from '@/modules/shared/components/icons/check-icon-toggle';

export default {
	name: 'job-hierarchy-box',
	components: { CheckIconToggle, CheckIcon, JobSelectorEditionDialog, EditIcon },
	props: [
		'assignationHasError',
		'jobPosition',
		'selectedJobPosition',
		'selected',
		'assignationId',
		'selectable',
		'clickable',
	],
	methods: {
		onEditClick() {
			this.$refs.jobSelectorEditionDialog.show(this.jobPosition);
		},
		onAssignClicked() {
			let fatherId = null;
			let fatherName = null;
			if (!this.jobPosition.fatherId) {
				fatherId = this.selectedJobPosition.id;
				fatherName = this.selectedJobPosition.name;
			}
			this.$store.dispatch('jobEvaluation/updateAssignation', {
				assignationId: this.assignationId,
				jobPosition: pipe(
					assoc('fatherId', fatherId),
					assoc('fatherName', fatherName),
				)(this.jobPosition),
			});
		},
		onSelectedClick() {
			if (this.clickable && this.selectable) {
				this.$emit('click');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.job-hierarchy-box {
	padding: 20px;
	color: var(--app-color-primary);
	font-weight: bold;
	border: 1px solid var(--app-color-primary);
	border-radius: 10px;
	width: 200px;
	min-height: 80px;
	user-select: none;
	position: relative;
	.edit-button {
		cursor: pointer;
	}
	.job-father {
		color: var(--app-color-info);
		font-size: 12px;
		font-weight: normal;
	}
	.check-assignation {
		position: absolute;
		top: 4px;
		left: 4px;
	}
	.assign {
		cursor: pointer;
	}
	&.clickable {
		cursor: pointer;
	}
	&.has-error {
		border: 1px solid var(--app-color-error);
		color: var(--app-color-error);
	}
	&.selected {
		background-color: var(--app-color-primary);
		color: white;
		.job-father {
			color: white;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-box.vue